import React from 'react';
import HomeContent from '../../components/Pages/Home';
import { displayName } from '../../App';

export default function Home(): React.ReactElement {
  document.title = `${displayName}: Home page`;

  return <HomeContent />;
}
